document.addEventListener('DOMContentLoaded', () => {
  const beadOptionName = 'Bead';                 // Option 1 name
  const restrictedBeadValues = ['6mm', '8mm'];   // Beads that cannot have charm
  const charmOptionName = 'Charm';               // Option 2 name
  const restrictedCharmValue = 'With Charm';     // Value to hide

  // Listen for variant option change
  document.addEventListener('change', () => {
    const selectedBead = getSelectedOptionValue(beadOptionName);
    const charmOptions = getOptionValueLabels(charmOptionName);

    if (!selectedBead || charmOptions.length === 0) return;

    if (restrictedBeadValues.includes(selectedBead)) {
      // Hide With Charm for 6mm & 8mm
      charmOptions.forEach(label => {
        if (label.textContent.trim() === restrictedCharmValue) {
          label.style.display = 'none';
        }
      });
    } else {
      // Show back all charm options for 4mm
      charmOptions.forEach(label => {
        label.style.display = '';
      });
    }
  });

  // Get currently selected value for an option
  function getSelectedOptionValue(optionName) {
    const legend = [...document.querySelectorAll('.product-form__input legend')]
      .find(el => el.textContent.trim() === optionName);
    if (!legend) return null;

    const fieldset = legend.closest('fieldset');
    const checked = fieldset.querySelector('input:checked');
    return checked ? checked.value.trim() : null;
  }

  // Fetch labels for an option
  function getOptionValueLabels(optionName) {
    const legend = [...document.querySelectorAll('.product-form__input legend')]
      .find(el => el.textContent.trim() === optionName);
    if (!legend) return [];

    return [...legend.closest('fieldset').querySelectorAll('label')];
  }
});
